// Mock data for development - realistic spark journal entries
const mockSparks = [
  {
    id: 'a1b2c3d4-e5f6-7890-abcd-ef1234567890',
    moment: 'Reading an article about biomimicry in architecture',
    why: 'Nature solves lighting with almost zero waste, and that felt like a design north star.',
    intensity: 3,
    tellingYou: 'I care deeply about sustainable design and want my work to reflect natural systems.',
    compelledTo: 'Design a lamp inspired by how fireflies create light without heat.',
    timeframe: 'already',
    completed: true,
    createdAt: new Date(Date.now() - 14 * 24 * 60 * 60 * 1000).toISOString(),
    updatedAt: new Date(Date.now() - 2 * 24 * 60 * 60 * 1000).toISOString(),
  },
  {
    id: 'b2c3d4e5-f6a7-8901-bcde-f23456789012',
    moment: 'Met a ceramicist at the farmers market who talked about "happy accidents".',
    why: 'It made me rethink how I treat mistakes in my work.',
    intensity: 2,
    tellingYou: 'I have a perfectionist streak that gets in the way of making things.',
    compelledTo: 'Research wabi-sabi philosophy and how imperfection is celebrated in Japanese aesthetics.',
    timeframe: 'week',
    completed: false,
    createdAt: new Date(Date.now() - 12 * 24 * 60 * 60 * 1000).toISOString(),
    updatedAt: new Date(Date.now() - 12 * 24 * 60 * 60 * 1000).toISOString(),
  },
  {
    id: 'c3d4e5f6-a7b8-9012-cdef-345678901234',
    moment: 'Podcast about the 100 year life and multiple careers.',
    why: '',
    intensity: 1,
    tellingYou: null,
    compelledTo: 'Sketch ideas for a side project that could grow into a second career.',
    timeframe: 'month',
    completed: false,
    createdAt: new Date(Date.now() - 10 * 24 * 60 * 60 * 1000).toISOString(),
    updatedAt: new Date(Date.now() - 10 * 24 * 60 * 60 * 1000).toISOString(),
  },
  {
    id: 'd4e5f6a7-b8c9-0123-def0-456789012345',
    moment: 'Walked past a community garden and saw people teaching kids to plant seeds.',
    why: 'The intergenerational energy felt like something I wanted to support.',
    intensity: 3,
    tellingYou: 'Giving back and mentoring is something I value more than I act on.',
    compelledTo: 'Volunteer to teach basic design skills at the community center.',
    timeframe: 'already',
    completed: true,
    createdAt: new Date(Date.now() - 9 * 24 * 60 * 60 * 1000).toISOString(),
    updatedAt: new Date(Date.now() - 5 * 24 * 60 * 60 * 1000).toISOString(),
  },
  {
    id: 'e5f6a7b8-c9d0-1234-ef01-567890123456',
    moment: 'Conference talk about "ambient computing" and interfaces that disappear.',
    why: 'It challenged my assumption that attention is the primary metric.',
    intensity: 2,
    tellingYou: null,
    compelledTo: 'Study calm technology principles and redesign one flow with less friction.',
    timeframe: 'week',
    completed: false,
    createdAt: new Date(Date.now() - 8 * 24 * 60 * 60 * 1000).toISOString(),
    updatedAt: new Date(Date.now() - 8 * 24 * 60 * 60 * 1000).toISOString(),
  },
  {
    id: 'f6a7b8c9-d0e1-2345-f012-678901234567',
    moment: 'Watched a documentary about how mushrooms communicate through mycelium networks.',
    why: '',
    intensity: 1,
    tellingYou: null,
    compelledTo: 'Create a visualization of interconnected ideas that grows organically.',
    timeframe: 'month',
    completed: false,
    createdAt: new Date(Date.now() - 6 * 24 * 60 * 60 * 1000).toISOString(),
    updatedAt: new Date(Date.now() - 6 * 24 * 60 * 60 * 1000).toISOString(),
  },
  {
    id: 'a7b8c9d0-e1f2-3456-0123-789012345678',
    moment: 'Friend mentioned she journals by drawing instead of writing.',
    why: 'It sounded like a way to bypass my overthinking.',
    intensity: 3,
    tellingYou: 'I intellectualize too much and need more tactile, unfiltered creative outlets.',
    compelledTo: 'Try visual journaling for one week with no words.',
    timeframe: 'already',
    completed: true,
    createdAt: new Date(Date.now() - 5 * 24 * 60 * 60 * 1000).toISOString(),
    updatedAt: new Date(Date.now() - 1 * 24 * 60 * 60 * 1000).toISOString(),
  },
  {
    id: 'b8c9d0e1-f2a3-4567-1234-890123456789',
    moment: 'Bookstore had a section called "Books that changed our staff\'s lives".',
    why: 'I realized I never curated my own list with intention.',
    intensity: 1,
    tellingYou: null,
    compelledTo: 'Create my own "Books that changed me" shelf and ask friends for theirs.',
    timeframe: 'month',
    completed: false,
    createdAt: new Date(Date.now() - 4 * 24 * 60 * 60 * 1000).toISOString(),
    updatedAt: new Date(Date.now() - 4 * 24 * 60 * 60 * 1000).toISOString(),
  },
  {
    id: 'c9d0e1f2-a3b4-5678-2345-901234567890',
    moment: 'Noticed how much calmer I felt after 10 minutes of stretching.',
    why: 'It was the smallest habit with the biggest shift in my day.',
    intensity: 2,
    tellingYou: 'My body knows what I need before my brain does.',
    compelledTo: 'Build a "micro-ritual" library with 5-minute activities for different moods.',
    timeframe: 'week',
    completed: false,
    createdAt: new Date(Date.now() - 2 * 24 * 60 * 60 * 1000).toISOString(),
    updatedAt: new Date(Date.now() - 2 * 24 * 60 * 60 * 1000).toISOString(),
  },
  {
    id: 'e1f2a3b4-c5d6-7890-4567-123456789012',
    moment: 'Attended a community dinner where strangers cooked recipes from their home countries.',
    why: 'Food became a bridge — everyone had a story and a reason to be there.',
    intensity: 3,
    tellingYou: null,
    compelledTo: 'Organize a neighborhood potluck and invite people I\'ve never spoken to.',
    timeframe: 'month',
    completed: false,
    createdAt: new Date(Date.now() - 3 * 24 * 60 * 60 * 1000).toISOString(),
    updatedAt: new Date(Date.now() - 3 * 24 * 60 * 60 * 1000).toISOString(),
  },
  {
    id: 'd0e1f2a3-b4c5-6789-3456-012345678901',
    moment: 'Saw a street artist transform an ugly electrical box into a beautiful mural.',
    why: '',
    intensity: 2,
    tellingYou: null,
    compelledTo: 'Find the "ugly boxes" in my daily work and make them delightful.',
    timeframe: 'month',
    completed: false,
    createdAt: new Date(Date.now() - 1 * 24 * 60 * 60 * 1000).toISOString(),
    updatedAt: new Date(Date.now() - 1 * 24 * 60 * 60 * 1000).toISOString(),
  },
];

export function getInitialSparks() {
  return mockSparks;
}

export default mockSparks;
